import useJWT from '../../jwt/useJWT';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAddressCard, faHome, faPerson, faRightFromBracket, faRightToBracket, faShoppingBasket } from '@fortawesome/free-solid-svg-icons'
import {useSelector} from "react-redux";
import {checkRole} from "../../utils/Helpers";
import React from "react";
import logo from '../../assets/images/hrr-logo.svg';

const Header = () => {
	const { logout, isAuthenticated } = useJWT();

	const user = useSelector(state => state.user);
	const basketRoles = [
		'admin',
		'regatta-admin',
		'coach',
		'commentator',
		'regatta-finance',
		'boattent'
	]

	let canViewBasket = false;

	if(user?.user?.role) {
		canViewBasket = basketRoles.map(role => checkRole(user?.user?.role, role, false))
			.includes(true);
	}

	const doLogout = () => {
		logout({
			returnTo: window.location.origin,
		});

		// delete localstorage token
		localStorage.removeItem('hrr_access_token');
	};



	return (
		<header>
			<div className="container-fluid navbar-expand-md">
				<div className="row align-items-center">
					<div className="col-6">
						<Link to="/" className="site-title">
							<img src={logo} alt="Henley Royal Regatta" className="img-fluid"/>
						</Link>
					</div>
					<div className="col-6 text-end">
						<div className="nav-links">
							{
								(isAuthenticated) &&
								<>
									<Link to="/account"><FontAwesomeIcon icon={faAddressCard} /></Link>
									{canViewBasket && (<Link to="/basket"><FontAwesomeIcon icon={faShoppingBasket} /></Link>)}
								</>
							}
							{
								(isAuthenticated) ? (
									<button onClick={() => doLogout()} className="btn"><FontAwesomeIcon icon={faRightFromBracket} /></button>
								) : <Link to="/login"><FontAwesomeIcon icon={faRightToBracket} /></Link>
							}
							{
								isAuthenticated && (
									<button className="navbar-toggler collapsed" type="button" data-bs-toggle="collapse"
											data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
											aria-expanded="false" aria-label="Toggle navigation">
										<span className="navbar-toggler-icon"></span>
									</button>
								)
							}
						</div>
					</div>
				</div>
			</div>
		</header>
	);
};

export default Header;
